export default function ArrowCircleIcon() {
  return (
    <svg fill="currentColor" viewBox="0 0 26 26">
      <path d="M13 0C5.83203 0 0 5.83203 0 13C0 20.168 5.83203 26 13 26C20.168 26 26 20.168 26 13C26 5.83203 20.168 0 13 0ZM13 2C19.0859 2 24 6.91406 24 13C24 19.0859 19.0859 24 13 24C6.91406 24 2 19.0859 2 13C2 6.91406 6.91406 2 13 2ZM12 6V16.2812L8 12.2812L6.59375 13.7188L13 20.125L19.4062 13.7188L18 12.2812L14 16.2812V6H12Z" />
    </svg>
  );
}
